import React from "react";
import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import "../styles/AboutUsDropdown.css"; 

function AboutUsDropdown({ onLinkClick, scrolled, menuOpen }) {
  const isArrowDark = scrolled || menuOpen;

  return (
    <div className="about-us-dropdown-wrapper">
      <FiChevronDown
        className={`dropdown-arrow ${
          isArrowDark ? "dropdown-arrow-dark" : "dropdown-arrow-light"
        }`}
      />
      <div className="about-us-dropdown-content">
        <Link to="/journey" onClick={onLinkClick}>
          Our Journey
        </Link>
      </div>
    </div>
  );
}

export default AboutUsDropdown;